(function () {
  'use strict';
  angular.module('MktzapApp.Factories')
    .factory('AutoReportService', AutoReportService);

  AutoReportService.$inject = ['$resource'];

  function AutoReportService ($resource) {
    return $resource('', {}, {
      getAutoReports: { url: apiUrl + '/auto-reports', method: 'GET', isArray: false },
      saveAutoReports: { url: apiUrl + '/auto-reports', method: 'POST', isArray: false },
      removeAutoReports: { url: apiUrl + '/auto-reports', method: 'DELETE', isArray: false },
      sendAutoReport: { url: apiUrl + '/auto-reports/send', method: 'GET', isArray: false }
    });
  }
})();
